module.exports = __webpack_public_path__ + "img/layout3.e279bd1a.png";